<template>
  <div>
    <div class="row no-gutters py-2">
      <div class="col-md-4">
        <div class="row-form mr-2">
          <label for="">Tìm kiếm</label>
          <base-input placeholder="Nhập mã hoặc tên sản phẩm..." v-model="listQuery.search"></base-input>
        </div>
      </div>
      <div class="col-md-2">
        <div class="row-form mr-2">
          <label for="">Đơn vị</label>
          <base-select v-model="listQuery.unit" :options="['M', 'Yard', 'Kg', 'Sợi']"></base-select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="row-form mr-2">
          <label for="">Màu sắc</label>
          <color style="max-width:100%" v-model="colorSearch"></color>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary btn-sm btn-block" @click="doSearch()">
          Tìm kiếm
        </button>
      </div>
    </div>
    <b-row class="mt-2 no-gutters">
      <b-col md="4">
        <block :nobody="true" ref="buser" class="soft-control">
          <soft-table
            @rowSelected="tbSetRowSelected"
            @rowClicked="tbRowClicked"
            class="table align-items-center table-flush"
            tbody-classes="list"
            :pending="false"
            :dataTable="tableData"
            :fields="fields"
            :minHeight="$hMainContent - 64"
            @contextMenuItemClick="tbHandleContextMenuItemClick"
            @doEditRow="handleUpdate"
            @doDeleteRow="handleDelete"
            :noDelete="true"
            ref="soft-table"
          >
            <template v-slot:cell(userCreate)="{ value }">
              <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
            </template>
            <template v-slot:cell(userVerify)="{ value }">
              <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
              <span v-else class="badge badge-danger">Chưa được duyệt</span>
            </template>
            <template v-slot:cell(userManage)="{ value }">
              <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
              <span v-else class="badge badge-danger">Chưa có người hỗ trợ</span>
            </template>
            <template>
              <pagination
                class="mt-2 mb-2 mr-2"
                slot="footer"
                :total="listQuery.total"
                :perPage="listQuery.limit"
                @change="pagChange"
              />
            </template>
          </soft-table>
        </block>
      </b-col>
      <b-col md="2">
        <spec-product ref="spec" @specProductSelected="specSelected"></spec-product>
      </b-col>
      <b-col md="6">
        <spec-product-unit
          @reloadProductInfo="$emit('reloadProductInfo')"
          @specProductUnitSelected="specProductUnitSelected"
          ref="specunit"
        ></spec-product-unit>
      </b-col>
    </b-row>
    <product-modal @submit:success="fetchData" :type="type" ref="productModal"></product-modal>
  </div>
</template>
<script>
import { productService } from '@/_services';
import SpecProduct from './__SpecProduct';
import SpecProductUnit from './__SpecProductUnit';

import ProductModal from './__ProductModal';
export default {
  props: {
    type: {}
  },
  components: {
    SpecProduct,
    ProductModal,
    SpecProductUnit
  },
  data() {
    return {
      tableData: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          key: 'code',
          label: 'Mã sản phẩm',
          class: 'text-left',
          sortable: true
        },
        {
          key: 'name',
          label: 'Tên sản phẩm',
          class: 'text-left'
        },
        {
          key: 'action',
          class: 'text-center'
        }
      ],
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        type: this.type
      },
      colorSearch: null,
      lastIndexCustomerSelected: 0,
      info: {}
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    doSearch() {
      this.listQuery.colorId = this.colorSearch ? this.colorSearch.id : null;
      this.fetchData();
    },
    fetchData() {
      productService.findAll(this.listQuery).then(res => {
        this.tableData = res.data.data;
        this.listQuery.total = res.data.total;
        this.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
      });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.$emit('productSelected', item, index);
      this.lastIndexCustomerSelected = index;
      this.$refs.specunit.setData(item, []);
      this.$refs.spec.setData(item);
    },
    specSelected(product, item, index) {
      //this.$emit("specProductSelected", product, item, index);
      this.$refs.specunit.setData(product, item.childs);
    },
    specProductUnitSelected(item) {
      this.$emit('specProductUnitSelected', item, this.info);
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate() {
      this.$refs.productModal.visible = true;
      this.$refs.productModal.setData(this.info);
    },
    handleCreate() {
      this.$refs.productModal.visible = true;
      this.$refs.productModal.setData(false);
    },
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.countChecked = items.length;
    }
  },
  watch: {
    countChecked: function() {
      this.$emit('countCheckedChange', this.countChecked);
    }
  }
};
</script>
